// extracted by mini-css-extract-plugin
module.exports = {"AccordionContainer":"accordion_AccordionContainer__2zyQX","settingsCard":"accordion_settingsCard__yI0W-","title":"accordion_title__2aXaN","Content":"accordion_Content__kiKqr"};